import React, { useEffect, useState } from 'react';

import { Provider } from '../../_helpers/Contexts/mainContext';
import api from '../../_helpers/Request/api';
import { Navbar } from '../Navbar/Navbar';
import { Footer } from '../Footer/Footer';
import { ProgressDots } from '../ProgressDots/ProgressDots';
import baner from '../../_assets/baner.png';
import { ProgressDots2023 } from '../ProgressDots/ProgressDots2023';
import { ProgressDots2023_D2 } from '../ProgressDots/ProgressDots2023_D2';

interface LayoutInterface {
    title: string;
    children: React.ReactNode;
}

const Layout: React.FC<LayoutInterface> = ({ title, children }) => {
    const [theme, setTheme] = useState<string>('default');
    const [sizeTheme, setSizeTheme] = useState<number>(100);
    const [step, setStep] = useState<string>('');
    const [ifManagerGlobal, setManagerGlobal] = useState<boolean>(false);
    const [saveCurrentStep, setSaveCurrentStep] = useState<any>();
    const [is2023, setIs2023] = useState<boolean>(false);
    const [componentName, setComponentName] = useState<string>();

    useEffect(() => {
        var value = localStorage.getItem('D1');
        if (value) {
            setIs2023(true);
        } else {
            setIs2023(false);
        }

        if (value && value === '1') {
            setComponentName('D1');
        } else if (value && value === '2') {
            setComponentName('D2');
        } else {
            setComponentName('OLD');
        }
    }, []);

    useEffect(() => {
        document.documentElement.className = theme;
    }, [theme]);

    useEffect(() => {
        document.body.style.zoom = sizeTheme + '%';
    }, [sizeTheme]);

    const RenderItem = () => {
        switch (componentName) {
            case 'D1':
                return <ProgressDots2023 />;
            case 'D2':
                return <ProgressDots2023_D2 />;
            case 'OLD':
                return <ProgressDots />;
            default:
                return <ProgressDots2023 />;
        }
    };
    return (
        <Provider
            value={{
                theme,
                setTheme,
                sizeTheme,
                setSizeTheme,
                step,
                setStep,
                ifManagerGlobal,
                setManagerGlobal
            }}
        >
            <Navbar title={title} />
            <div className="main">
                <div className="col-12">
                    <div className="mainHeader" style={{ backgroundImage: `url(${baner})` }}></div>
                </div>
                <div className="container-fluid">
                    <div className="row layout">
                        <div id="anchor"></div>
                        <div className="col-12 col-xl-9 left">{children}</div>
                        <div className="col-12 col-xl-3 attachments">{RenderItem()}</div>
                        {/* <div className="col-12 col-xl-3 attachments">{is2023 ? <ProgressDots2023 /> : <ProgressDots />}</div> */}
                    </div>
                </div>
            </div>
            <Footer />
        </Provider>
    );
};

export { Layout };
